import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Link, useTheme } from '@mui/material';

import * as AuthActions from '../../../../store/actions/auth.action';
import { getUser } from '../../../../store/selector/auth.selector';
import OtpForm from '../../ui/layout/otp-form';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },

  OtpContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '25rem',
  },
};

const AuthOtpForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  const user = useSelector(getUser);
  const [otp, setOtp] = useState('');

  useEffect(() => {
    if (user && user.token) {
      if (user.is_hr) {
        navigate('/hr');
      } else {
        navigate('/approvals');
      }
    }
  }, [user]);

  const onChangeHandler = (e: string) => {
    setOtp(e);
  };

  const onSubmitHandler = async () => {
    if (otp) dispatch(AuthActions.Otp(user.email, otp));
  };

  const switchAccount = () => {
    dispatch(AuthActions.Logout());
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.OtpContainer}>
        <OtpForm onClick={onSubmitHandler} onChange={onChangeHandler} token={otp} />
        <Typography
          onClick={switchAccount}
          sx={{
            mt: '0.5rem',
            textDecoration: 'none',
            color: theme.palette.primary.main,
            cursor: 'pointer',
          }}
        >
          Switch Account
        </Typography>
      </Box>
    </Box>
  );
};

export default AuthOtpForm;
